import { API } from "../../api.js";
import { $, esc } from "../../ui/format.js";
import { helpIcon } from "../../ui/help.js";

// ---------------------------------------------------------------- World & Company News

async function renderNews(main, snap) {
  main.innerHTML = `
    <h2 class="panel-title">World &amp; Company News — Month ${snap.month} ${helpIcon("news")}</h2>
    <div class="commands" id="news-subtabs">
      <button data-nsub="world" class="primary">World News</button>
      <button data-nsub="company">Company News</button>
    </div>
    <div id="news-content">Loading…</div>
  `;
  const data = await fetch(`${API}/news`).then((x) => x.json());
  let newsSubTab = "world";

  function renderNewsList() {
    const content = $("news-content");
    const articles = newsSubTab === "world" ? data.world : data.company;
    if (!articles.length) {
      content.innerHTML = `<p style="color:var(--text-mid); font-size:13px;">Nothing to report yet — check back after a few months of play.</p>`;
      return;
    }
    content.innerHTML = articles.map((a) => `
      <div class="news-article" style="border-bottom:1px solid var(--line); padding:16px 0;">
        ${a.section ? `<div style="font-size:11px; color:var(--brass); text-transform:uppercase; letter-spacing:0.06em; margin-bottom:4px;">${esc(a.section)}</div>` : ""}
        <div style="font-family:var(--font-display); font-size:16px; font-weight:600; margin-bottom:6px;">${esc(a.headline)}</div>
        <div style="font-size:13.5px; color:var(--text-mid); line-height:1.55;">${esc(a.body)}</div>
        <div style="font-size:11px; color:var(--text-low); margin-top:8px; font-family:var(--font-mono);">Month ${a.month}</div>
        ${a.why ? `<details class="news-why"><summary>Why did this happen?</summary><p>${esc(a.why.why)}</p>
          <p class="news-why-fix"><b>What helps:</b> ${esc(a.why.fix)} <button type="button" data-news-go="${esc(a.why.tab)}">Go there →</button></p></details>` : ""}
      </div>
    `).join("");
    content.querySelectorAll("[data-news-go]").forEach((b) => b.addEventListener("click", () => window.ges && window.ges.showTab(b.dataset.newsGo)));
  }

  $("news-subtabs").querySelectorAll("[data-nsub]").forEach((btn) => {
    btn.addEventListener("click", () => {
      newsSubTab = btn.dataset.nsub;
      $("news-subtabs").querySelectorAll("[data-nsub]").forEach((b) => b.classList.toggle("primary", b.dataset.nsub === newsSubTab));
      renderNewsList();
    });
  });
  renderNewsList();
}

export { renderNews };
